<template>
  <transition name="fade">
    <signin v-if="isLoginOpen" @close="onCloseSignin" @signup="isLoginOpen = false;isSignupOpen = true"/>
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <transition name="fade">
    <join v-if="isSignupOpen" @close="onCloseSignup"/>
  </transition>

  <transition name="fade">
    <join-complete v-if="isSignupCompleteOpen" @close="isSignupCompleteOpen = false;isLoginOpen = true"/>
  </transition>

  <transition name="fade">
    <new-message v-if="isUnReadMessage" />
  </transition>

  <header v-if="gameCount" id="mainheader" :class="{'mainPage': $route.name === 'main'}">
    <div class="header-inner">
      <!-- 로고 -->
      <div class="logo mega-brand">
        <a @click="goPageByName('main')">
          <img src="@/assets/img/noir19/mega-logo-transparent.png" alt="MEGA" />
        </a>
      </div>
      <!-- 중앙 메뉴 -->
      <nav class="gnb">
        <ul class="navi">
          <li class="dropdown" :class="{active: $route.name === 'main'}">
            <a class="dropdown-toggle" @click="goPageByName('main')">게임</a>
          </li>
          <li class="dropdown" @mouseover="gnbMenuOpen('notice')">
            <a class="dropdown-toggle" @click="goPageByName('notice')">{{ $t('front.common.notice') }}</a>
          </li>
          <li class="dropdown"><a class="dropdown-toggle" @click="goPageByName('charge')">입금</a></li>
          <li class="dropdown"><a class="dropdown-toggle" @click="goPageByName('exchange')">출금</a></li>
          <li class="dropdown"><a class="dropdown-toggle" @click="goPageByName('mypage')">베팅기록</a></li>
          <li class="dropdown"><a class="dropdown-toggle" @click="goPageByName('csCenter')">고객센터</a></li>
          <!-- <li class="dropdown" @mouseover="gnbMenuOpen('mypage')" v-if="userData">
            <a class="dropdown-toggle" @click="goPageByName('mypage')">{{ $t('front.common.mypage') }}</a>
          </li> -->
          <li class="dropdown" @mouseover="gnbMenuOpen('partner')" v-if="userData">
            <a
              class="dropdown-toggle"
              :href="`https://${partnerDomain}/partnerMain`"
              target="_blank"
              v-if="userData.isPartnerMember && userData.isPartnerMember === 'Y'"
            >
              {{ $t('front.common.partner') }}
            </a>
          </li>
        </ul>
      </nav>
      <!-- 오른쪽 로그인/회원정보 -->
      <div class="header-right">
        <template v-if="!userData">
          <button class="header-login-btn" @click="onClickLogin">
            {{ $t('front.gnb.login') }}
          </button>
          <button class="header-signup-btn" @click="isSignupOpen = true">회원가입</button>
        </template>

        <template v-else>
          <ul class="coninpoint">
            <li class="header-user-name">
              <span>{{ userData.memNick }}</span>
            </li>
          </ul>

          <div class="logindropdown">
            <button class="logindropbtn">
              <strong>₩{{ thousand(userData.cashAmt ? userData.cashAmt.toString() : '0') }}</strong>
              <span>포인트: {{ thousand(userData.pointAmt ? userData.pointAmt.toString() : '0') }}</span>
            </button>

            <div class="logindropdown-content moneywrap">
              <a @click="goPageByName('mypage')">계정 정보</a>
              <a @click="goPageByName('point')">포인트 전환</a>
              <a @click="goPageByName('message')">
                쪽지
                <em class="msg-count">{{ thousand(unReadMessageCount ? unReadMessageCount.toString() : '0') }}</em>
              </a>
            </div>
          </div>

          <button class="header-login-btn" @click="signOut">
            {{ $t('front.common.logout') }}
          </button>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
// import UiButton from '@/components/ui/UiButton'
import { mapState } from 'vuex'
import Join from '@/components/member/Join'
import JoinComplete from '@/components/member/JoinComplete'
import Signin from '@/components/member/Signin'
import TMmodal from '@/components/common/TotalMoney'
import { TRIPLE_GAME_LIST } from '@/libs/constants'
import NewMessage from '@/components/member/Message.vue'

export default {
  name: 'Header',
  components: {
    NewMessage,
    Signin,
    JoinComplete,
    Join,
    // UiButton,
    TMmodal
  },
  data () {
    return {
      menuList: [],
      TMOpen: false,
      isLoginOpen: false,
      isSignupOpen: false,
      isSignupCompleteOpen: false,
      showMenu: false,
      showMenuMoney: false,
      showMenuLang: false,
      isAlertOpen: false,
      isGameOpen: false,
      isSlotOpen: false,
      isSportsOpen: false,
      isMiniOpen: false,
      isCashOpen: false,
      tripleGameList: TRIPLE_GAME_LIST
    }
  },
  watch: {
    $route: {
      handler (current) {
        this.gnbReset()
      }
    }
  },
  created () {
    this.setMenu()
    this.getHeadMsgList()
  },
  computed: {
    ...mapState([
      'userData',
      'coinAmt',
      'commonCodeByOrder',
      'gameCount',
      'unReadMessageCount'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    },
    partnerDomain () {
      const hostname = window.location.hostname
      if (hostname.includes('port-folio.cc')) return 'd29.port-folio.cc'
      return 'd29.port-folio.cc' // 기본값
    }
  },
  methods: {
    slotOpen (event, groupCode, codeName, code) {
      this.emitter.emit(event, { groupCode, codeName, code })
    },
    gnbReset () {
      this.isGameOpen = false
      this.isSlotOpen = false
      this.isSportsOpen = false
      this.isMiniOpen = false
      this.isCashOpen = false
      this.showMenu = false
      this.showMenuLang = false
    },
    gnbMenuOpen (type) {
      this.gnbReset()
      if (type === 'game') {
        this.isGameOpen = true
      } else if (type === 'slot') {
        this.isSlotOpen = true
      } else if (type === 'cash') {
        this.isCashOpen = true
      } else if (type === 'mypage') {
        this.showMenu = true
      } else if (type === 'lang') {
        this.showMenuLang = true
      } else if (type === 'sport') {
        this.isSportsOpen = true
      } else if (type === 'minigame') {
        this.isMiniOpen = true
      }
    },
    getHeadMsgList () {
      // getHeadMsg({}).then(response => {
      //   console.log(response)
      // })
    },
    setMenu () {
      const list = this.$router.getRoutes()
      for (let i = 0, iLen = list.length; i < iLen; i++) {
        const item = list[i]
        if (item.meta && item.meta.gnb) {
          item.isSubOpen = false
          this.menuList.push(item)
        }
      }
    },
    getBackgroundImage (item) {
      try {
        const image = require('../assets/img/game_main_pc_' + item.code + '_off.png')
        const imageOff = require('../assets/img/game_main_pc_' + item.code + '_off.png')

        if (item.isHover) {
          return { backgroundImage: 'url(' + image + ')' }
        } else {
          return { backgroundImage: 'url(' + imageOff + ')' }
        }
      } catch (e) {
        return { backgroundImage: 'url()' }
      }
    },
    onClickGame (code, name) {
      this.gnbReset()
      if (code) {
        // minigame

        if (code === 'mg') {
          this.$router.push({ name: name })
        } else {
          this.onSelectGame(code)
        }
      } else {
        this.onCheck('준비 중입니다.')
      }
    },
    onClickGnb (item) {
      const name = item.name
      const meta = item.meta
      if (meta.game) {
        this.onSelectGame(meta.gameCode)
      } else {
        this.$router.push({ name: name })
      }
    },
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    onClickLogin () {
      this.isLoginOpen = true
      this.isSignupOpen = false
    },
    onClickSignup () {
      this.isLoginOpen = false
      this.isSignupOpen = true
    },
    onCloseSignin (value) {
      this.isLoginOpen = false
      if (value === 'join') {
        this.isSignupOpen = true
      }
      if (value === 'signin') {
        // location.reload()
      }
    },
    onCloseSignup (status) {
      this.isSignupOpen = false
      if (status) {
        this.isSignupCompleteOpen = true
      }
    }
  }
}
</script>

<style scoped src="@/styles/burgundy-header.css"></style>
